// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1M33n","content":"styles_content__m377E"};